export default __webpack_public_path__ + "static/media/Book1.29be2170.jpg";